import React from 'react';
import Image from 'next/image';
import SubmitButton from '@/components/SubmitButton';
import UniversalModal from '@/components/modal/UniversalModal';
import setAlertValue from '@/components/Alert';
import { SearchType } from '@/types/job-title';
import { Option } from '@/components/form/cascade-select/CascadeSelect';
import { NATION_WIDE } from '@/constants/city';
import { subscribeJob } from '@/api/tanzhi';
import emailIcon from '@/assets/job-title/email.png';

type Props = {
  open: boolean;
  email: string;
  searchValue: SearchType;
  cityValue: Option;
  handleSuccess: () => void;
  handleClose: () => void;
};

const SubscribeModal = (props: Props) => {
  const { open, email, searchValue, cityValue, handleSuccess, handleClose } =
    props;
  const [submit, setSubmit] = React.useState(false);

  const handleSubmit = () => {
    if (!email || !searchValue?.id) {
      setAlertValue({ msg: '请填写邮箱和职位', severity: 'warning' });
      return;
    }
    subscribeJob(email, searchValue, cityValue || NATION_WIDE)
      .then(() => {
        handleClose();
        handleSuccess();
      })
      .catch((error) =>
        setAlertValue({
          msg: error.response.data?.detail || '订阅失败，请尝试重新订阅',
        }),
      )
      .finally(() => setSubmit(false));
  };

  const handleClick = () => {
    if (!email || !searchValue?.id) {
      setAlertValue({ msg: '请填写邮箱和职位', severity: 'warning' });
      return;
    }
    setSubmit(true);
  };

  return (
    <UniversalModal
      open={open}
      onClose={handleClose}
      title={<></>}
      headerHeight={76}
      headerBorder=""
      headerClass="font-semibold"
      width={426}
      maxWidth={false}
      footer={<></>}
      fullScreen={false}
    >
      <div className="p-10 pt-0 tablet:p-20 tablet:pt-3">
        <Image alt="" src={emailIcon} width={64} height={77} />
        <p className="mt-6 font-semibold text-xl">请确认你的订阅邮箱</p>
        <p className="mt-2 mb-6 text-sm leading-6.5">{email}</p>
        <SubmitButton
          submit={submit}
          submitText="订阅"
          className="!w-full !h-12"
          handleClick={handleClick}
          handleSubmit={handleSubmit}
        />
      </div>
    </UniversalModal>
  );
};

export default SubscribeModal;
